/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { WorkbookId } from "../../commons/types/WorkbookId";
export const AiGenerateBlueprintConstraintsJobConfig = core.serialization.object({
    spaceId: SpaceId,
    workbookId: WorkbookId,
});
